// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {AssessablePanelMode} from "@common/components/assessment/utils";
import {Translations} from "@translations";

@Component({
	selector: "sim-assessment-examiner-note",
	templateUrl: "./assessment-examiner-note.component.html",
	styleUrls: ["./assessment-examiner-note.component.scss"],
	standalone: false,
})
export class AssessmentExaminerNoteComponent {
	protected readonly AssessablePanelMode = AssessablePanelMode;
	protected readonly T = Translations;

	@Input({required: true}) note: string;
	@Input({required: true}) mode: AssessablePanelMode;

	noteChange = output<string>();
}
